module.exports = __webpack_public_path__ + "101fbc9e7ef97375be9ee8403f969bbf.svg";